
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9OhGR", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ab96820cdb7ca90$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $2SlZp = parcelRequire("2SlZp");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $jjCkw = parcelRequire("jjCkw");


var $19BZl = parcelRequire("19BZl");


var $7K3dX = parcelRequire("7K3dX");


var $fNh3C = parcelRequire("fNh3C");


var $7K83z = parcelRequire("7K83z");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $e5Nax = parcelRequire("e5Nax");


var $2FkI9 = parcelRequire("2FkI9");




const $0b21ce6c65459807$var$LEGACY_MAX_ITEMS = 10;
const $0b21ce6c65459807$var$OVERFLOW_MAX_ITEMS = 50;
function $0b21ce6c65459807$var$NativeMenuSection({ namedItems: namedItems, sectionIndex: sectionIndex, totalMenuItemsCount: totalMenuItemsCount, sectionStartIndex: sectionStartIndex, nativeSectionCount: nativeSectionCount }) {
    const [showAll, setShowAll] = (0, $42omo.useState)(false);
    const { fireNewNativeMenuItemClicked: fireNewNativeMenuItemClicked, fireNewNativeMenuItemClickedOld: fireNewNativeMenuItemClickedOld, fireShowMoreButtonClicked: fireShowMoreButtonClicked } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const { product: product } = (0, $19BZl.useMenuControl)();
    const sectionItemsCount = namedItems.items.length;
    const foldableThreshold = (0, $7K83z.getFoldableThreshold)(namedItems.foldable);
    const items = (0, $42omo.useMemo)(()=>{
        if (!sectionItemsCount) return [];
        if (!namedItems.foldable || sectionItemsCount <= foldableThreshold) return namedItems.items;
        const sectionItemsLimit = (0, $dh538.fg)('navx_universal_create_overflow_mode') ? $0b21ce6c65459807$var$OVERFLOW_MAX_ITEMS : $0b21ce6c65459807$var$LEGACY_MAX_ITEMS;
        return namedItems.items.slice(0, showAll ? sectionItemsLimit : foldableThreshold);
    }, [
        namedItems,
        showAll,
        sectionItemsCount,
        foldableThreshold
    ]);
    const toggleShowMore = (0, $42omo.useCallback)(()=>{
        if (typeof namedItems.foldable === 'number' && (0, $dh538.fg)('navx-2610-uc-refactor-show-more')) {
            setShowAll(true); // removing show less functionality under this fg
            fireShowMoreButtonClicked({
                groupHeading: namedItems.heading || 'unknown',
                groupIndex: sectionIndex,
                groupItemCount: sectionItemsCount,
                inMoreItemAtisList: namedItems.items.slice(foldableThreshold).map((item)=>item.ati.toString()),
                inMoreItemCount: sectionItemsCount - foldableThreshold
            });
        } else setShowAll((prev)=>!prev);
    }, [
        setShowAll,
        namedItems,
        sectionIndex,
        sectionItemsCount,
        fireShowMoreButtonClicked,
        foldableThreshold
    ]);
    const menuItemWithAnalytics = (0, $42omo.useCallback)((item, itemIndex)=>{
        const fireAnalytics = (isRightClick)=>{
            const itemAti = item.ati.toString();
            if ((0, $dh538.fg)('navx-2236-unified-instrumentation-updates')) fireNewNativeMenuItemClicked({
                nativeGroupCount: nativeSectionCount,
                nativeItemCount: totalMenuItemsCount,
                nativeItemIndex: sectionStartIndex + itemIndex,
                groupItemCount: sectionItemsCount,
                groupItemIndex: itemIndex,
                groupItemAti: itemAti,
                groupItemProduct: product,
                isInMore: false,
                isRightClick: isRightClick
            });
            else fireNewNativeMenuItemClickedOld({
                ati: itemAti,
                menuItemsCount: totalMenuItemsCount,
                // Total number of items in the native sections part of menu
                menuItemIndex: sectionStartIndex + itemIndex,
                // Position of the item in the native sections part of menu
                groupItemProduct: product,
                groupItemsCount: sectionItemsCount,
                // Number of items in the section
                groupItemsIndex: itemIndex,
                isRightClick: // Position of the item in the section
                isRightClick
            });
        };
        return {
            ...item,
            onClick: (event)=>{
                fireAnalytics(false);
                item.onClick?.(event);
            },
            onContextMenu: (event)=>{
                fireAnalytics(true);
                item.onContextMenu?.(event);
            }
        };
    }, [
        fireNewNativeMenuItemClickedOld,
        fireNewNativeMenuItemClicked,
        totalMenuItemsCount,
        sectionStartIndex,
        sectionItemsCount,
        product,
        nativeSectionCount
    ]);
    if (!namedItems?.items?.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2FkI9.default), {
        sectionIndex: sectionIndex,
        itemLength: namedItems.items.length,
        foldable: namedItems.foldable,
        heading: namedItems.heading,
        showAll: showAll,
        toggleShowMore: toggleShowMore,
        isNative: true,
        children: items.map((menuItem, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $e5Nax.default), {
                item: menuItemWithAnalytics(menuItem, index)
            }, `menu-section-${sectionIndex}-item-${index}`))
    });
}
var $0b21ce6c65459807$export$2e2bcd8739ae039 = (0, $fNh3C.withIntlProvider)($0b21ce6c65459807$var$NativeMenuSection);


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $lAJUP = parcelRequire("lAJUP");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");





var $fP8Uu = parcelRequire("fP8Uu");





var $fMjA6 = parcelRequire("fMjA6");

var $6OnN8 = parcelRequire("6OnN8");




var $iXlHQ = parcelRequire("iXlHQ");





var $7WMLZ = parcelRequire("7WMLZ");

/* SuggestionItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $9DI9J = parcelRequire("9DI9J");


var $56Pe5 = parcelRequire("56Pe5");


var $csJ3R = parcelRequire("csJ3R");

/* LinkItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");

/* SuggestionItemBase.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $6yCpa = parcelRequire("6yCpa");








var $33MPL = parcelRequire("33MPL");




const $27f0e6b33328c20f$var$noop = ()=>{};
function $27f0e6b33328c20f$export$b5de039d8eaccb66({ responseItem: responseItem, customisedItemConfig: customisedItemConfig, itemIndex: itemIndex, totalItemsCount: totalItemsCount }) {
    const { suggestionConfig: suggestionConfig } = (0, $19BZl.useMenuControl)();
    const { fireNewSuggestionsMenuItemClicked: fireNewSuggestionsMenuItemClicked, fireNewSuggestionsMenuItemClickedOld: fireNewSuggestionsMenuItemClickedOld } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const onClick = (0, $42omo.useCallback)(()=>{
        const onItemClick = suggestionConfig?.enabled && suggestionConfig?.onItemClick || $27f0e6b33328c20f$var$noop;
        if ((0, $dh538.fg)('navx-2236-unified-instrumentation-updates')) fireNewSuggestionsMenuItemClicked({
            groupItemCount: totalItemsCount,
            groupItemIndex: itemIndex,
            groupItemAti: responseItem.ati,
            groupItemProduct: responseItem.product,
            isRightClick: false
        });
        else fireNewSuggestionsMenuItemClickedOld({
            ati: responseItem.ati,
            groupItemProduct: responseItem.product,
            groupItemsCount: totalItemsCount,
            groupItemsIndex: itemIndex,
            isRightClick: false,
            menuItemIndex: itemIndex,
            menuItemsCount: totalItemsCount
        });
        // TODO: add skip condition in the future for platform items, such as goal, project or team forms.
        onItemClick?.(responseItem.ati);
    }, [
        suggestionConfig,
        responseItem,
        fireNewSuggestionsMenuItemClickedOld,
        fireNewSuggestionsMenuItemClicked,
        itemIndex,
        totalItemsCount
    ]);
    const [icon, setIcon] = (0, $42omo.useState)(undefined);
    const [isIconLoading, setIsIconLoading] = (0, $42omo.useState)(false);
    const { isLoading: isCustomisedItemConfigLoading, ...restCustomisedItemConfig } = customisedItemConfig || {};
    const onRightClick = (0, $42omo.useCallback)((event)=>{
        // Fire analytics first
        if ((0, $dh538.fg)('navx-2236-unified-instrumentation-updates')) fireNewSuggestionsMenuItemClicked({
            groupItemCount: totalItemsCount,
            groupItemIndex: itemIndex,
            groupItemAti: responseItem.ati,
            groupItemProduct: responseItem.product,
            isRightClick: true
        });
        else fireNewSuggestionsMenuItemClickedOld({
            ati: responseItem.ati,
            groupItemProduct: responseItem.product,
            groupItemsCount: totalItemsCount,
            groupItemsIndex: itemIndex,
            isRightClick: true,
            menuItemIndex: itemIndex,
            menuItemsCount: totalItemsCount
        });
        // Then call custom onContextMenu handler if provided
        const customOnContextMenu = restCustomisedItemConfig?.onContextMenu;
        customOnContextMenu?.(event);
    }, [
        fireNewSuggestionsMenuItemClicked,
        fireNewSuggestionsMenuItemClickedOld,
        responseItem,
        totalItemsCount,
        itemIndex,
        restCustomisedItemConfig?.onContextMenu
    ]);
    (0, $42omo.useEffect)(function loadIcon() {
        if (!responseItem.icon) {
            setIcon(undefined);
            setIsIconLoading(false);
            return;
        }
        setIsIconLoading(true);
        (0, $33MPL.iconLoader)(responseItem.icon).then((loadedIcon)=>{
            if (loadedIcon) setIcon(()=>loadedIcon);
            else setIcon(undefined);
            setIsIconLoading(false);
        });
    }, [
        responseItem.icon
    ]);
    // Extract custom onClick handler and compose with analytics onClick
    const customOnClick = restCustomisedItemConfig?.onClick;
    const composedOnClick = (0, $42omo.useCallback)((event)=>{
        // Fire analytics first
        onClick();
        // Then call custom click handler if provided
        customOnClick?.(event);
    }, [
        customOnClick,
        onClick
    ]);
    const menuItem = (0, $42omo.useMemo)(()=>{
        const { onClick: _, onContextMenu: __, ...otherCustomConfig } = restCustomisedItemConfig || {};
        return {
            ati: (0, $6yCpa.Ati).parse(responseItem.ati),
            children: responseItem.name,
            elemBefore: icon,
            isLoading: isIconLoading || isCustomisedItemConfigLoading,
            testId: `suggestion-item-${responseItem.ati}`,
            onClick: customOnClick ? composedOnClick : onClick,
            onContextMenu: onRightClick,
            ...otherCustomConfig
        };
    }, [
        responseItem.ati,
        responseItem.name,
        icon,
        isIconLoading,
        isCustomisedItemConfigLoading,
        onClick,
        composedOnClick,
        customOnClick,
        restCustomisedItemConfig,
        onRightClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e5Nax.default), {
        item: menuItem
    });
}






var $39XmP = parcelRequire("39XmP");


var $kfZYI = parcelRequire("kfZYI");







function $43cfab306ab8c906$var$getUrlEnv(serverSessionSyncUrl) {
    const url = new URL(serverSessionSyncUrl);
    if (url.hostname === 'id.stg.internal.atlassian.com') return 'staging';
    if (url.hostname === 'id.atlassian.com') return 'prod';
    return null;
}
function $43cfab306ab8c906$var$compileIcSessionSyncUrl(serverSessionSyncUrl) {
    const env = $43cfab306ab8c906$var$getUrlEnv(serverSessionSyncUrl);
    const icEnvUrl = env ? (0, $kfZYI.getUrlForDomainInContext)('id', env) : undefined;
    if (icEnvUrl) {
        const icFinalUrl = new URL(serverSessionSyncUrl);
        const icEnvHostname = new URL(icEnvUrl).hostname;
        icFinalUrl.hostname = icEnvHostname;
        return icFinalUrl.toString();
    }
    return serverSessionSyncUrl;
}
function $43cfab306ab8c906$var$useBuildLinkItemUrl(item) {
    const { product: product, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    const buildUrlWithAnalyticsParams = (0, $39XmP.default)({
        bridge: 'universalCreate',
        product: product,
        subProduct: subProduct
    });
    if (!item.href || !item.hostname) return '';
    const base = item.hostname.startsWith('https://') ? item.hostname : `https://${item.hostname}`;
    const targetUrl = new URL(item.href, base);
    // Add query parameters from options
    for (const [key, value] of Object.entries(item.options || {}))if (value !== null) targetUrl.searchParams.append(key, String(value));
    // Inject product param for Trello board
    if (item.ati === 'ati:cloud:trello:board' && (0, $dh538.fg)('navx-uc-onboarding-trello')) targetUrl.searchParams.append('product', product);
    const finalTargetUrl = buildUrlWithAnalyticsParams(targetUrl.toString());
    // Handle session sync URL logic
    if (!item.sessionSyncUrl) // When session sync URL is empty, return the current URL
    return finalTargetUrl;
    // When session sync URL is set, use it as base and set continue param to current URL
    const finalSessionSyncUrl = $43cfab306ab8c906$var$compileIcSessionSyncUrl(item.sessionSyncUrl);
    const sessionSyncUrl = new URL(finalSessionSyncUrl);
    sessionSyncUrl.searchParams.set('continue', finalTargetUrl);
    return sessionSyncUrl.toString();
}
function $43cfab306ab8c906$export$42845b6a2d6a3ac1(item) {
    const { suggestionConfig: suggestionConfig } = (0, $19BZl.useMenuControl)();
    const href = $43cfab306ab8c906$var$useBuildLinkItemUrl(item);
    // Priority: explicit config > item target > default '_blank'
    const target = suggestionConfig?.enabled ? suggestionConfig.suggestionLinkOpenTarget || item.target || '_blank' : item.target || '_blank';
    const onClick = (0, $42omo.useCallback)((event)=>{
        event.preventDefault();
        window.parent.location.href = href;
    }, [
        href
    ]);
    return (0, $42omo.useMemo)(()=>{
        // Only add rel attributes for _blank targets to prevent security issues
        const rel = target === '_blank' ? 'noopener noreferrer' : undefined;
        // Only add onClick handler for _self targets in iframes with valid href to minimize impact
        const shouldAddOnClick = href && target === '_self' && window !== window.parent && (0, $dh538.fg)('navx_universal_create_self_redirect_iframe');
        return {
            target: target,
            rel: rel,
            href: href,
            ...shouldAddOnClick && {
                onClick: onClick
            }
        };
    }, [
        href,
        target,
        onClick
    ]);
}


/**
 * Higher-order component that wraps a component with link item configuration
 * @param WrappedComponent - The component to wrap with link item configuration
 * @returns A new component with link item configuration applied
 */ function $1b108bbe34f9b79a$var$withLinkItemConfig(WrappedComponent) {
    return function WithLinkItemConfigComponent(props) {
        const linkItemConfig = (0, $43cfab306ab8c906$export$42845b6a2d6a3ac1)(props.responseItem);
        if (!linkItemConfig.href) return null; // early return should now show the item when computed href is invalid
        return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            customisedItemConfig: linkItemConfig
        });
    };
}
const $1b108bbe34f9b79a$export$532cb6865ebe8946 = $1b108bbe34f9b79a$var$withLinkItemConfig((0, $27f0e6b33328c20f$export$b5de039d8eaccb66));


/* LoomVideoItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");






var $hf2X4 = parcelRequire("hf2X4");


var $h03W7 = parcelRequire("h03W7");

const $a045c9e8d9067aa0$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    loomVideo: {
        id: "universal-create.loom-video-menu-item.create-loom-video",
        defaultMessage: "Loom video"
    }
});
/**
 * Higher-order component that wraps a component with Loom video configuration
 * @param WrappedComponent - The component to wrap with Loom video configuration
 * @returns A new component with Loom video configuration applied
 */ function $a045c9e8d9067aa0$var$withLoomVideoConfig(WrappedComponent) {
    return function WithLoomVideoConfigComponent(props) {
        const { context: context, product: product } = props;
        const customisedItemConfig = (0, $hf2X4.useLoomVideoConfig)({
            cloudId: context.cloudId,
            productName: (0, $h03W7.convertSourceProductToProductType)(product),
            environment: context.environment || 'prod',
            onItemClick: context.onItemClick
        });
        const finalItemConfig = {
            ...customisedItemConfig
        };
        return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            customisedItemConfig: finalItemConfig
        });
    };
}
const $a045c9e8d9067aa0$export$7b2dceeaf04ce250 = $a045c9e8d9067aa0$var$withLoomVideoConfig((0, $27f0e6b33328c20f$export$b5de039d8eaccb66));



function $54e4d0be0033339a$var$renderPlatformSuggestionItem({ responseItem: responseItem, itemIndex: itemIndex, totalItemsCount: totalItemsCount, context: context, product: product, subProduct: subProduct }) {
    switch(responseItem.ati){
        case (0, $9DI9J.ATI_PRESETS).LOOM:
            {
                const LoomVideoItem = (0, $dh538.fg)('navx-2470-migrate-loom-integration') ? (0, $56Pe5.withLoomVideoConfig)((0, $27f0e6b33328c20f$export$b5de039d8eaccb66)) : (0, $a045c9e8d9067aa0$export$7b2dceeaf04ce250);
                return /*#__PURE__*/ (0, $l998X.jsx)(LoomVideoItem, {
                    responseItem: responseItem,
                    context: context,
                    product: product,
                    subProduct: subProduct,
                    itemIndex: itemIndex,
                    totalItemsCount: totalItemsCount
                });
            }
        case (0, $9DI9J.ATI_PRESETS).GOAL:
        case (0, $9DI9J.ATI_PRESETS).PROJECT:
        case (0, $9DI9J.ATI_PRESETS).TEAM:
            {
                if (!(0, $dh538.fg)('navx_uc_platformisation_forms_enabled')) return null; // should not show this item if the feature flag is off
                const loadCreateContent = (0, $csJ3R.getCreateContentLoader)(responseItem.ati);
                const customisedItemConfig = {
                    loadCreateContent: loadCreateContent,
                    onClickCloseMenu: !loadCreateContent
                };
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $27f0e6b33328c20f$export$b5de039d8eaccb66), {
                    responseItem: responseItem,
                    itemIndex: itemIndex,
                    totalItemsCount: totalItemsCount,
                    customisedItemConfig: customisedItemConfig
                });
            }
        default:
            return undefined;
    }
}
function $54e4d0be0033339a$var$renderSuggestionItem({ responseItem: responseItem, itemIndex: itemIndex, totalItemsCount: totalItemsCount, context: context, product: product, subProduct: subProduct }) {
    switch(responseItem.type){
        case 'platform':
            return $54e4d0be0033339a$var$renderPlatformSuggestionItem({
                responseItem: responseItem,
                itemIndex: itemIndex,
                totalItemsCount: totalItemsCount,
                context: context,
                product: product,
                subProduct: subProduct
            });
        case 'link':
            return(// eslint-disable-next-line @atlassian/a11y/anchor-is-valid, @atlassian/a11y/anchor-has-content -- See https://go/a11y-anchor-has-content for more details
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1b108bbe34f9b79a$export$532cb6865ebe8946), {
                responseItem: responseItem,
                context: context,
                product: product,
                itemIndex: itemIndex,
                totalItemsCount: totalItemsCount
            }));
        default:
            break;
    }
    return undefined;
}
function $54e4d0be0033339a$var$SuggestionItemInner({ responseItem: responseItem, itemIndex: itemIndex, totalItemsCount: totalItemsCount, context: context, product: product, subProduct: subProduct }) {
    if (context) {
        const renderedItem = $54e4d0be0033339a$var$renderSuggestionItem({
            responseItem: responseItem,
            itemIndex: itemIndex,
            totalItemsCount: totalItemsCount,
            context: context,
            subProduct: subProduct,
            product: product
        });
        if (renderedItem !== undefined) return renderedItem;
    }
    // Return general suggestion item with no customisedItemConfig
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $27f0e6b33328c20f$export$b5de039d8eaccb66), {
        responseItem: responseItem,
        itemIndex: itemIndex,
        totalItemsCount: totalItemsCount
    });
}
function $54e4d0be0033339a$export$18af743539b68cfc(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($54e4d0be0033339a$var$SuggestionItemInner, {
            ...props
        })
    });
}


const $be7df9cf7c49e65b$var$messages = (0, $cgtv4.defineMessages)({
    sectionHeading: {
        id: "platform.navigation-experiences.universal-create.suggestion.section-heading",
        defaultMessage: "{count, plural, one {Suggestion} other {Suggestions}}"
    }
});
function $be7df9cf7c49e65b$var$SuggestionMenuSectionContent() {
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const { mixedItems: mixedItems, product: product, suggestionConfig: suggestionConfig, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    const cloudId = suggestionConfig.enabled ? suggestionConfig.cloudId : '';
    const orgId = suggestionConfig.enabled ? suggestionConfig.orgId : '';
    const userId = suggestionConfig.enabled ? suggestionConfig.accountId : '';
    const compact = suggestionConfig.enabled && !!suggestionConfig.compact;
    const location = suggestionConfig.enabled ? suggestionConfig.location : 'end'; // Use the shared hooks for ATIs logic
    const nativeAtis = (0, $6OnN8.useSuggestionNativeAtis)();
    const preferredAtis = (0, $fMjA6.useSuggestionPreferredAtis)();
    const excludeAtis = (0, $fMjA6.useSuggestionExcludeAtis)();
    const { data: data, isLoading: isLoading, hasError: hasError } = (0, $fP8Uu.useUCSuggestions)({
        cloudId: cloudId,
        orgId: orgId,
        userId: userId,
        product: product,
        subProduct: subProduct,
        locale: locale,
        nativeAtis: nativeAtis,
        preferredAtis: preferredAtis,
        excludeAtis: excludeAtis
    });
    const { fireNewSuggestionsMenuViewed_old: fireNewSuggestionsMenuViewed_old, fireNewSuggestionsMenuViewed: fireNewSuggestionsMenuViewed } = (0, $7K3dX.useUniversalCreateAnalytics)();
    (0, $42omo.useEffect)(()=>{
        const items = data?.items;
        if (items?.length) {
            const suggestedItems = items.map((item)=>item.ati);
            if ((0, $dh538.fg)('navx-2236-unified-instrumentation-updates')) fireNewSuggestionsMenuViewed({
                crossAppSuggestionsEnabled: suggestionConfig.enabled || false,
                suggestionsGroupCount: 0,
                suggestionsItemCount: items.length,
                suggestionGroupList: [
                    {
                        // Note: Currently only one suggestion section is supported, and more button is not in use
                        groupHeading: formatMessage($be7df9cf7c49e65b$var$messages.sectionHeading, {
                            count: items.length
                        }),
                        groupIndex: 0,
                        groupItemAtisList: suggestedItems,
                        groupItemCount: items.length
                    }
                ]
            });
            else fireNewSuggestionsMenuViewed_old({
                crossAppSuggestionsEnabled: suggestionConfig.enabled || false,
                suggestionMenuGroup: {
                    displayModeCompact: compact,
                    itemAtis: suggestedItems,
                    suggestionLocation: location,
                    showMoreButton: false
                },
                totalSuggestionItems: items.length
            });
        }
    }, [
        data,
        fireNewSuggestionsMenuViewed,
        fireNewSuggestionsMenuViewed_old,
        formatMessage,
        compact,
        location,
        suggestionConfig.enabled
    ]);
    if (suggestionConfig.enabled && isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $iXlHQ.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7WMLZ.SkeletonItem), {
            testId: "loading-suggestion-section"
        })
    });
    if (!suggestionConfig.enabled || hasError || !data?.items?.length) return null;
    const items = data.items;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2FkI9.default), {
        sectionIndex: location === 'start' ? 0 : mixedItems.length + 1,
        itemLength: items.length,
        showAll: true,
        compact: compact,
        heading: formatMessage($be7df9cf7c49e65b$var$messages.sectionHeading, {
            count: items.length
        }),
        isNative: false,
        children: items.map((responseItem, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $54e4d0be0033339a$export$18af743539b68cfc), {
                responseItem: responseItem,
                context: suggestionConfig,
                product: product,
                subProduct: subProduct,
                itemIndex: index,
                totalItemsCount: items.length
            }, `suggestion-menu-item-${responseItem.ati}`))
    });
}
function $be7df9cf7c49e65b$export$2e2bcd8739ae039() {
    // We need better error boundary, this is a temporary solution
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($be7df9cf7c49e65b$var$SuggestionMenuSectionContent, {})
    });
}


const $6ab96820cdb7ca90$var$styles = {
    menuWrap: "_ca0qu2gc _n3tdu2gc"
};
function $6ab96820cdb7ca90$var$MenuContent() {
    const { mixedItems: mixedItems, suggestionConfig: suggestionConfig } = (0, $19BZl.useMenuControl)();
    const crossAppCreationEnabled = (0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled');
    const { fireNewNativeMenuViewed_old: fireNewNativeMenuViewed_old, fireNewNativeMenuViewed: fireNewNativeMenuViewed } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const analyticsFired = (0, $42omo.useRef)(false);
    // Check if any menu items are currently loading
    const hasLoadingItems = mixedItems.some((section)=>section.items.some((item)=>item.isLoading === true));
    const sectionsToAnalyze = mixedItems.slice(0, (0, $jjCkw.MAX_ALLOWED_SECTIONS));
    (0, $42omo.useEffect)(()=>{
        if (mixedItems.length > 0 && !hasLoadingItems && !analyticsFired.current) {
            const totalNativeItems = sectionsToAnalyze.reduce((total, section)=>total + section.items.length, 0);
            let unnamedSectionIndex = 0;
            if ((0, $dh538.fg)('navx-2236-unified-instrumentation-updates')) {
                const sections = sectionsToAnalyze.map((namedItem, sectionIndex)=>{
                    const moreButtonEnabled = (0, $7K83z.hasMoreButton)(namedItem.foldable, namedItem.items.length);
                    return {
                        groupHeading: namedItem.heading || `native-section-${unnamedSectionIndex++}`,
                        groupIndex: sectionIndex,
                        // Index of section out of all sections
                        groupItemCount: namedItem.items.length,
                        // total number of items in the section
                        groupItemAtisList: moreButtonEnabled ? namedItem.items.slice(0, (0, $7K83z.getFoldableThreshold)(namedItem.foldable)).map((item)=>item.ati.toString()) : namedItem.items.map((item)=>item.ati.toString()),
                        inMoreItemAtisList: moreButtonEnabled ? namedItem.items.slice((0, $7K83z.getFoldableThreshold)(namedItem.foldable)).map((item)=>item.ati.toString()) : [],
                        inMoreItemCount: moreButtonEnabled ? namedItem.items.length - (0, $7K83z.getFoldableThreshold)(namedItem.foldable) : 0,
                        showMoreButton: moreButtonEnabled // true if items in section have been truncated with show more button
                    };
                });
                fireNewNativeMenuViewed({
                    crossAppSuggestionsEnabled: crossAppCreationEnabled,
                    nativeGroupCount: sectionsToAnalyze.length,
                    nativeItemCount: totalNativeItems,
                    nativeMenuGroups: sections
                });
            } else {
                const sections = sectionsToAnalyze.map((namedItem, sectionIndex)=>({
                        groupHeading: namedItem.heading || `native-section-${unnamedSectionIndex++}`,
                        groupIndex: sectionIndex,
                        // Index of section out of all sections
                        groupItemCount: namedItem.items.length,
                        // total number of items in the section
                        itemAtis: namedItem.items.map((item)=>item.ati.toString()),
                        // Atis of items in the section
                        showMoreButton: (0, $7K83z.hasMoreButton)(namedItem.foldable, namedItem.items.length) // true if items in section have been truncated with show more button
                    }));
                fireNewNativeMenuViewed_old({
                    crossAppSuggestionsEnabled: crossAppCreationEnabled,
                    totalGroups: sectionsToAnalyze.length,
                    totalNativeItems: totalNativeItems,
                    nativeMenuGroups: sections
                });
            }
            analyticsFired.current = true;
        }
    }, [
        mixedItems,
        hasLoadingItems,
        crossAppCreationEnabled,
        fireNewNativeMenuViewed,
        fireNewNativeMenuViewed_old,
        sectionsToAnalyze
    ]);
    // Reset analytics when loading state changes
    (0, $42omo.useEffect)(()=>{
        if (hasLoadingItems) analyticsFired.current = false;
    }, [
        hasLoadingItems
    ]);
    if (!mixedItems.length) return null;
    const isSuggestionSectionEnabled = crossAppCreationEnabled && suggestionConfig.enabled;
    // including a check for enabled here ensures we avoid error TS2339 Property location does not exist on type SuggestionConfigDisabled
    const showSuggestionsAtStart = suggestionConfig?.enabled && suggestionConfig?.location === 'start';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        spacing: "compact",
        testId: "global-create-content-popover-menu",
        ...sectionsToAnalyze.some((section)=>typeof section.foldable === 'number') && (0, $dh538.fg)('navx_universal_create_overflow_mode') ? {
            maxHeight: (0, $jjCkw.MAX_MENU_HEIGHT)
        } : undefined,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($6ab96820cdb7ca90$var$styles.menuWrap),
            children: [
                isSuggestionSectionEnabled && showSuggestionsAtStart && /*#__PURE__*/ (0, $l998X.jsx)((0, $be7df9cf7c49e65b$export$2e2bcd8739ae039), {}),
                sectionsToAnalyze.map((namedItem, sectionIndex)=>{
                    const totalNativeItems = sectionsToAnalyze.reduce((total, section)=>total + section.items.length, 0);
                    // Calculate the starting index for this section by summing items from all previous sections
                    const sectionStartIndex = sectionsToAnalyze.slice(0, sectionIndex).reduce((total, section)=>total + section.items.length, 0);
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $0b21ce6c65459807$export$2e2bcd8739ae039), {
                        namedItems: namedItem,
                        sectionIndex: isSuggestionSectionEnabled && showSuggestionsAtStart && !suggestionConfig.compact ? sectionIndex + 1 : sectionIndex,
                        totalMenuItemsCount: totalNativeItems,
                        sectionStartIndex: sectionStartIndex,
                        nativeSectionCount: sectionsToAnalyze.length
                    }, `menu-section-${sectionIndex}`);
                }),
                isSuggestionSectionEnabled && !showSuggestionsAtStart && /*#__PURE__*/ (0, $l998X.jsx)((0, $be7df9cf7c49e65b$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
var $6ab96820cdb7ca90$export$2e2bcd8739ae039 = (0, $fNh3C.withIntlProvider)($6ab96820cdb7ca90$var$MenuContent);

});

parcelRegister("3IXul", function(module, exports) {

let $2b63a056f4abe2e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2b63a056f4abe2e1$var$load("lXGg9"),
    $2b63a056f4abe2e1$var$load("hy3sK"),
    $2b63a056f4abe2e1$var$load("aeEUI"),
    $2b63a056f4abe2e1$var$load("awqCy"),
    $2b63a056f4abe2e1$var$load("jSdjl"),
    $2b63a056f4abe2e1$var$load("l2EUC"),
    $2b63a056f4abe2e1$var$load("kWZnd"),
    $2b63a056f4abe2e1$var$load("92LGf"),
    $2b63a056f4abe2e1$var$load("6wr18"),
    $2b63a056f4abe2e1$var$load("5Qf5y"),
    $2b63a056f4abe2e1$var$load("jtcRz"),
    $2b63a056f4abe2e1$var$load("1Pok1"),
    $2b63a056f4abe2e1$var$load("4F6Xw"),
    $2b63a056f4abe2e1$var$load("lkOIY"),
    $2b63a056f4abe2e1$var$load("is5Sk"),
    $2b63a056f4abe2e1$var$load("l8LQp"),
    $2b63a056f4abe2e1$var$load("hRUX7"),
    $2b63a056f4abe2e1$var$load("g4oYs"),
    $2b63a056f4abe2e1$var$load("kHOMt"),
    $2b63a056f4abe2e1$var$load("hhss7"),
    $2b63a056f4abe2e1$var$load("Wowvf"),
    $2b63a056f4abe2e1$var$load("ffEVr"),
    $2b63a056f4abe2e1$var$load("kUbUu"),
    $2b63a056f4abe2e1$var$load("7EorR"),
    $2b63a056f4abe2e1$var$load("eZu0L")
]).then(()=>parcelRequire('dwZXA'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("kkzdO", function(module, exports) {

let $ecd0ff31fa4ed9b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ecd0ff31fa4ed9b0$var$load("lXGg9"),
    $ecd0ff31fa4ed9b0$var$load("hy3sK"),
    $ecd0ff31fa4ed9b0$var$load("kWZnd"),
    $ecd0ff31fa4ed9b0$var$load("92LGf"),
    $ecd0ff31fa4ed9b0$var$load("6wr18"),
    $ecd0ff31fa4ed9b0$var$load("5Qf5y"),
    $ecd0ff31fa4ed9b0$var$load("icsjv"),
    $ecd0ff31fa4ed9b0$var$load("jvHRs"),
    $ecd0ff31fa4ed9b0$var$load("hyzoX"),
    $ecd0ff31fa4ed9b0$var$load("9XYQ9"),
    $ecd0ff31fa4ed9b0$var$load("hRUX7"),
    $ecd0ff31fa4ed9b0$var$load("g4oYs"),
    $ecd0ff31fa4ed9b0$var$load("kHOMt"),
    $ecd0ff31fa4ed9b0$var$load("hhss7"),
    $ecd0ff31fa4ed9b0$var$load("Wowvf"),
    $ecd0ff31fa4ed9b0$var$load("7EorR"),
    $ecd0ff31fa4ed9b0$var$load("ffEVr"),
    $ecd0ff31fa4ed9b0$var$load("kUbUu"),
    $ecd0ff31fa4ed9b0$var$load("g55vn")
]).then(()=>parcelRequire('6mjFu'));

});

parcelRegister("53RUv", function(module, exports) {

let $3af70d0540974283$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3af70d0540974283$var$load("kWZnd"),
    $3af70d0540974283$var$load("92LGf"),
    $3af70d0540974283$var$load("6wr18"),
    $3af70d0540974283$var$load("5Qf5y"),
    $3af70d0540974283$var$load("69G8x"),
    $3af70d0540974283$var$load("kHOMt"),
    $3af70d0540974283$var$load("hhss7"),
    $3af70d0540974283$var$load("Wowvf"),
    $3af70d0540974283$var$load("7EorR"),
    $3af70d0540974283$var$load("ffEVr"),
    $3af70d0540974283$var$load("kUbUu"),
    $3af70d0540974283$var$load("hjuEj")
]).then(()=>parcelRequire('lG4Ng'));

});

parcelRegister("53z01", function(module, exports) {

let $3ae861b2f6a8e7ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ae861b2f6a8e7ee$var$load("hLVzM").then(()=>parcelRequire('e2ZTm'));

});

parcelRegister("036Ie", function(module, exports) {

let $00957ce6b4fad64a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $00957ce6b4fad64a$var$load("lRtGG").then(()=>parcelRequire('4ayWZ'));

});

parcelRegister("k8V49", function(module, exports) {

let $eaa0d21f1803064b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eaa0d21f1803064b$var$load("adH3p").then(()=>parcelRequire('f6IRL'));

});

parcelRegister("fq08g", function(module, exports) {

let $b39962ff7045cd7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b39962ff7045cd7b$var$load("4Jbf1").then(()=>parcelRequire('1qW0V'));

});

parcelRegister("eNNHQ", function(module, exports) {

let $ac6c32e5c80c429d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac6c32e5c80c429d$var$load("k97iL").then(()=>parcelRequire('lFkSe'));

});

parcelRegister("ji6i4", function(module, exports) {

let $e0b493e7dacf4679$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e0b493e7dacf4679$var$load("5BMnr").then(()=>parcelRequire('6uENn'));

});

parcelRegister("hf2X4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $9syPb = parcelRequire("9syPb");


var $9DI9J = parcelRequire("9DI9J");


var $jjCkw = parcelRequire("jjCkw");


var $19BZl = parcelRequire("19BZl");

const $c9b4f272f6863880$var$messages = (0, $cgtv4.defineMessages)({
    insertButtonText: {
        id: "universal-create.loom-video-menu-item.share-video",
        defaultMessage: "Share"
    }
});
function $c9b4f272f6863880$export$d8ef0486cf8cfe05({ cloudId: cloudId, productName: productName, environment: environment = 'prod', onItemClick: onItemClick, skipInitialisation: skipInitialisation = false }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isNav4Enabled: isNav4Enabled, product: product, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    const attributes = {
        isNav4: isNav4Enabled,
        product: product,
        subProduct: subProduct
    };
    const { openLoomRecorder: openLoomRecorder, recorderState: recorderState } = (0, $9syPb.useLoomRecorderEntryPoint)({
        entryPointLocation: (0, $jjCkw.SOURCE_LOCATION),
        environment: environment,
        cloudId: cloudId,
        productName: productName,
        onInsert: (videoUrl)=>{
            const url = new URL(videoUrl);
            // Open video in new tab with share permissions modal open
            url.searchParams.set('open_share_permissions', '1');
            window.open(url.toString(), '_blank', 'noopener');
        },
        insertButtonText: formatMessage($c9b4f272f6863880$var$messages.insertButtonText),
        eventHandler: {
            onRecordingComplete: ()=>createAnalyticsEvent({
                    action: 'completed',
                    actionSubject: 'loomRecording',
                    eventType: 'track',
                    tags: [
                        (0, $9DI9J.ANALYTICS_TAG)
                    ],
                    attributes: attributes
                }).fire((0, $9DI9J.ANALYTICS_CHANNEL)),
            onUploadComplete: ()=>createAnalyticsEvent({
                    action: 'uploaded',
                    actionSubject: 'loomRecording',
                    eventType: 'track',
                    tags: [
                        (0, $9DI9J.ANALYTICS_TAG)
                    ],
                    attributes: attributes
                }).fire((0, $9DI9J.ANALYTICS_CHANNEL)),
            onInsertClicked: ()=>createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'insertVideoLink',
                    eventType: 'ui',
                    tags: [
                        (0, $9DI9J.ANALYTICS_TAG)
                    ],
                    attributes: attributes
                }).fire((0, $9DI9J.ANALYTICS_CHANNEL))
        },
        skipInitialisation: skipInitialisation
    });
    const onClick = (0, $42omo.useCallback)(()=>{
        if (openLoomRecorder) {
            onItemClick?.((0, $9DI9J.ATI_PRESETS).LOOM);
            openLoomRecorder();
        }
    }, [
        openLoomRecorder,
        onItemClick
    ]);
    switch(recorderState){
        case 'initialising':
            return {
                isLoading: true
            };
        case 'ready':
            if (openLoomRecorder) return {
                onClick: onClick
            };
            return {
                isDisabled: true
            };
        default:
            return {
                isDisabled: true
            };
    }
}
module.exports["useLoomVideoConfig"] = $c9b4f272f6863880$export$d8ef0486cf8cfe05;

});

parcelRegister("hqYd7", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $2SlZp = parcelRequire("2SlZp");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $a1Oiu = parcelRequire("a1Oiu");


var $jjCkw = parcelRequire("jjCkw");


var $19BZl = parcelRequire("19BZl");


var $7K3dX = parcelRequire("7K3dX");


var $fNh3C = parcelRequire("fNh3C");


var $amdkE = parcelRequire("amdkE");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 














/* CrossAppItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $9DI9J = parcelRequire("9DI9J");


var $56Pe5 = parcelRequire("56Pe5");


var $csJ3R = parcelRequire("csJ3R");

/* CrossAppItemBase.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $6yCpa = parcelRequire("6yCpa");


var $33MPL = parcelRequire("33MPL");


var $e5Nax = parcelRequire("e5Nax");

const $4ef2ae8434994ccc$var$noop = ()=>{};
function $4ef2ae8434994ccc$export$671e3c96b60c4286({ responseItem: responseItem, customisedItemConfig: customisedItemConfig, context: context, injectClickAnalytics: injectClickAnalytics }) {
    const onClick = (0, $42omo.useCallback)(()=>{
        const onItemClick = context?.onItemClick || $4ef2ae8434994ccc$var$noop;
        // Call injected analytics for left click
        injectClickAnalytics?.onClick?.(false);
        // Call onItemClick callback if provided
        onItemClick?.(responseItem.ati);
    }, [
        context,
        responseItem,
        injectClickAnalytics
    ]);
    const [icon, setIcon] = (0, $42omo.useState)(undefined);
    const [isIconLoading, setIsIconLoading] = (0, $42omo.useState)(false);
    const { isLoading: isCustomisedItemConfigLoading, ...restCustomisedItemConfig } = customisedItemConfig || {};
    const onRightClick = (0, $42omo.useCallback)((event)=>{
        // Call injected analytics for right click
        injectClickAnalytics?.onClick?.(true);
        // Call custom onContextMenu handler if provided
        const customOnContextMenu = restCustomisedItemConfig?.onContextMenu;
        customOnContextMenu?.(event);
    }, [
        restCustomisedItemConfig?.onContextMenu,
        injectClickAnalytics
    ]);
    (0, $42omo.useEffect)(function loadIcon() {
        if (!responseItem.icon) {
            setIcon(undefined);
            setIsIconLoading(false);
            return;
        }
        setIsIconLoading(true);
        (0, $33MPL.iconLoader)(responseItem.icon).then((loadedIcon)=>{
            if (loadedIcon) setIcon(()=>loadedIcon);
            else setIcon(undefined);
            setIsIconLoading(false);
        });
    }, [
        responseItem.icon
    ]);
    // Extract custom onClick handler and compose with onClick
    const customOnClick = restCustomisedItemConfig?.onClick;
    const composedOnClick = (0, $42omo.useCallback)((event)=>{
        // Call onClick handler first
        onClick();
        // Then call custom click handler if provided
        customOnClick?.(event);
    }, [
        customOnClick,
        onClick
    ]);
    const menuItem = (0, $42omo.useMemo)(()=>{
        const { onClick: _, onContextMenu: __, ...otherCustomConfig } = restCustomisedItemConfig || {};
        return {
            ati: (0, $6yCpa.Ati).parse(responseItem.ati),
            children: responseItem.name,
            elemBefore: icon,
            isLoading: isIconLoading || isCustomisedItemConfigLoading,
            testId: `cross-app-item-${responseItem.ati}`,
            onClick: customOnClick ? composedOnClick : onClick,
            onContextMenu: onRightClick,
            ...otherCustomConfig
        };
    }, [
        responseItem.ati,
        responseItem.name,
        icon,
        isIconLoading,
        isCustomisedItemConfigLoading,
        onClick,
        composedOnClick,
        customOnClick,
        restCustomisedItemConfig,
        onRightClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e5Nax.default), {
        item: menuItem
    });
}


/* CrossAppLinkItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");






var $39XmP = parcelRequire("39XmP");


var $kfZYI = parcelRequire("kfZYI");







function $6e03daae58d17473$var$getUrlEnv(serverSessionSyncUrl) {
    const url = new URL(serverSessionSyncUrl);
    if (url.hostname === 'id.stg.internal.atlassian.com') return 'staging';
    if (url.hostname === 'id.atlassian.com') return 'prod';
    return null;
}
function $6e03daae58d17473$var$compileIcSessionSyncUrl(serverSessionSyncUrl) {
    const env = $6e03daae58d17473$var$getUrlEnv(serverSessionSyncUrl);
    const icEnvUrl = env ? (0, $kfZYI.getUrlForDomainInContext)('id', env) : undefined;
    if (icEnvUrl) {
        const icFinalUrl = new URL(serverSessionSyncUrl);
        const icEnvHostname = new URL(icEnvUrl).hostname;
        icFinalUrl.hostname = icEnvHostname;
        return icFinalUrl.toString();
    }
    return serverSessionSyncUrl;
}
function $6e03daae58d17473$var$useBuildLinkItemUrl(item) {
    const { product: product, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    const buildUrlWithAnalyticsParams = (0, $39XmP.default)({
        bridge: 'universalCreate',
        product: product,
        subProduct: subProduct
    });
    if (!item.href || !item.hostname) return '';
    const base = item.hostname.startsWith('https://') ? item.hostname : `https://${item.hostname}`;
    const targetUrl = new URL(item.href, base);
    // Add query parameters from options
    for (const [key, value] of Object.entries(item.options || {}))if (value !== null) targetUrl.searchParams.append(key, String(value));
    // Inject product param for Trello board
    if (item.ati === 'ati:cloud:trello:board' && (0, $dh538.fg)('navx-uc-onboarding-trello')) targetUrl.searchParams.append('product', product);
    const finalTargetUrl = buildUrlWithAnalyticsParams(targetUrl.toString());
    // Handle session sync URL logic
    if (!item.sessionSyncUrl) // When session sync URL is empty, return the current URL
    return finalTargetUrl;
    // When session sync URL is set, use it as base and set continue param to current URL
    const finalSessionSyncUrl = $6e03daae58d17473$var$compileIcSessionSyncUrl(item.sessionSyncUrl);
    const sessionSyncUrl = new URL(finalSessionSyncUrl);
    sessionSyncUrl.searchParams.set('continue', finalTargetUrl);
    return sessionSyncUrl.toString();
}
function $6e03daae58d17473$export$42845b6a2d6a3ac1(item, context) {
    const href = $6e03daae58d17473$var$useBuildLinkItemUrl(item);
    // Priority: explicit config > item target > default '_blank'
    const target = context.crossAppLinkOpenTarget || item.target || '_blank';
    const onClick = (0, $42omo.useCallback)((event)=>{
        event.preventDefault();
        window.parent.location.href = href;
    }, [
        href
    ]);
    return (0, $42omo.useMemo)(()=>{
        // Only add rel attributes for _blank targets to prevent security issues
        const rel = target === '_blank' ? 'noopener noreferrer' : undefined;
        // Only add onClick handler for _self targets in iframes with valid href to minimize impact
        const shouldAddOnClick = href && target === '_self' && window !== window.parent && (0, $dh538.fg)('navx_universal_create_self_redirect_iframe');
        return {
            target: target,
            rel: rel,
            href: href,
            ...shouldAddOnClick && {
                onClick: onClick
            }
        };
    }, [
        href,
        target,
        onClick
    ]);
}


/**
 * Higher-order component that wraps a component with link item configuration
 * @param WrappedComponent - The component to wrap with link item configuration
 * @returns A new component with link item configuration applied
 */ function $7dec05f53c1ad0f4$var$withLinkItemConfig(WrappedComponent) {
    return function WithLinkItemConfigComponent(props) {
        const linkItemConfig = (0, $6e03daae58d17473$export$42845b6a2d6a3ac1)(props.responseItem, props.context);
        if (!linkItemConfig.href) return null; // early return should not show the item when computed href is invalid
        return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            customisedItemConfig: linkItemConfig
        });
    };
}
const $7dec05f53c1ad0f4$export$995913b4338229ea = $7dec05f53c1ad0f4$var$withLinkItemConfig((0, $4ef2ae8434994ccc$export$671e3c96b60c4286));


/* LoomVideoItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");






var $cgtv4 = parcelRequire("cgtv4");




var $inPa6 = parcelRequire("inPa6");


var $9syPb = parcelRequire("9syPb");










const $91465855458ea778$var$messages = (0, $cgtv4.defineMessages)({
    insertButtonText: {
        id: "universal-create.loom-video-menu-item.share-video",
        defaultMessage: "Share"
    }
});
function $91465855458ea778$export$d8ef0486cf8cfe05({ cloudId: cloudId, productName: productName, environment: environment = 'prod', onItemClick: onItemClick, skipInitialisation: skipInitialisation = false }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isNav4Enabled: isNav4Enabled, product: product, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    const attributes = {
        isNav4: isNav4Enabled,
        product: product,
        subProduct: subProduct
    };
    const { openLoomRecorder: openLoomRecorder, recorderState: recorderState } = (0, $9syPb.useLoomRecorderEntryPoint)({
        entryPointLocation: (0, $jjCkw.SOURCE_LOCATION),
        environment: environment,
        cloudId: cloudId,
        productName: productName,
        onInsert: (videoUrl)=>{
            const url = new URL(videoUrl);
            // Open video in new tab with share permissions modal open
            url.searchParams.set('open_share_permissions', '1');
            window.open(url.toString(), '_blank', 'noopener');
        },
        insertButtonText: formatMessage($91465855458ea778$var$messages.insertButtonText),
        eventHandler: {
            onRecordingComplete: ()=>createAnalyticsEvent({
                    action: 'completed',
                    actionSubject: 'loomRecording',
                    eventType: 'track',
                    tags: [
                        (0, $9DI9J.ANALYTICS_TAG)
                    ],
                    attributes: attributes
                }).fire((0, $9DI9J.ANALYTICS_CHANNEL)),
            onUploadComplete: ()=>createAnalyticsEvent({
                    action: 'uploaded',
                    actionSubject: 'loomRecording',
                    eventType: 'track',
                    tags: [
                        (0, $9DI9J.ANALYTICS_TAG)
                    ],
                    attributes: attributes
                }).fire((0, $9DI9J.ANALYTICS_CHANNEL)),
            onInsertClicked: ()=>createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'insertVideoLink',
                    eventType: 'ui',
                    tags: [
                        (0, $9DI9J.ANALYTICS_TAG)
                    ],
                    attributes: attributes
                }).fire((0, $9DI9J.ANALYTICS_CHANNEL))
        },
        skipInitialisation: skipInitialisation
    });
    const onClick = (0, $42omo.useCallback)(()=>{
        if (openLoomRecorder) {
            onItemClick?.((0, $9DI9J.ATI_PRESETS).LOOM);
            openLoomRecorder();
        }
    }, [
        openLoomRecorder,
        onItemClick
    ]);
    switch(recorderState){
        case 'initialising':
            return {
                isLoading: true
            };
        case 'ready':
            if (openLoomRecorder) return {
                onClick: onClick
            };
            return {
                isDisabled: true
            };
        default:
            return {
                isDisabled: true
            };
    }
}


function $47aeebca6b9e8bb2$export$f8e8ac264d7fe02e(product, subProduct) {
    switch(product){
        case 'townsquare':
            if (subProduct === 'goal') return 'GOAL';
            if (subProduct === 'teams') return 'TEAMS';
            if (subProduct === 'home') return 'HOME';
            return 'TOWNSQUARE';
        case 'confluence':
            return 'CONFLUENCE';
        case 'rovoExtension':
            return 'ROVO_EXTENSION';
        default:
            return 'UNKNOWN';
    }
}
/**
 * Higher-order component that wraps a component with Loom video configuration
 * @param WrappedComponent - The component to wrap with Loom video configuration
 * @returns A new component with Loom video configuration applied
 */ function $47aeebca6b9e8bb2$var$withLoomVideoConfig(WrappedComponent) {
    return function WithLoomVideoConfigComponent(props) {
        const { context: context, product: product } = props;
        const customisedItemConfig = (0, $91465855458ea778$export$d8ef0486cf8cfe05)({
            cloudId: context.cloudId,
            productName: $47aeebca6b9e8bb2$export$f8e8ac264d7fe02e(product),
            environment: context.environment || 'prod',
            onItemClick: context.onItemClick
        });
        return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            ...props,
            customisedItemConfig: customisedItemConfig
        });
    };
}
const $47aeebca6b9e8bb2$export$7b2dceeaf04ce250 = $47aeebca6b9e8bb2$var$withLoomVideoConfig((0, $4ef2ae8434994ccc$export$671e3c96b60c4286));


function $3a24b12925157d12$var$renderPlatformCrossAppItem({ responseItem: responseItem, context: context, product: product, subProduct: subProduct, injectClickAnalytics: injectClickAnalytics }) {
    switch(responseItem.ati){
        case (0, $9DI9J.ATI_PRESETS).LOOM:
            {
                const LoomVideoItem = (0, $dh538.fg)('navx-2470-migrate-loom-integration') ? (0, $56Pe5.withLoomVideoConfig)((0, $4ef2ae8434994ccc$export$671e3c96b60c4286)) : (0, $47aeebca6b9e8bb2$export$7b2dceeaf04ce250);
                return /*#__PURE__*/ (0, $l998X.jsx)(LoomVideoItem, {
                    responseItem: responseItem,
                    context: context,
                    product: product,
                    injectClickAnalytics: injectClickAnalytics,
                    subProduct: subProduct
                });
            }
        case (0, $9DI9J.ATI_PRESETS).GOAL:
        case (0, $9DI9J.ATI_PRESETS).PROJECT:
        case (0, $9DI9J.ATI_PRESETS).TEAM:
            {
                if (!(0, $dh538.fg)('navx_uc_platformisation_forms_enabled')) return null; // should not show this item if the feature flag is off
                const loadCreateContent = (0, $csJ3R.getCreateContentLoader)(responseItem.ati);
                const customisedItemConfig = {
                    loadCreateContent: loadCreateContent,
                    onClickCloseMenu: !loadCreateContent
                };
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $4ef2ae8434994ccc$export$671e3c96b60c4286), {
                    responseItem: responseItem,
                    context: context,
                    customisedItemConfig: customisedItemConfig,
                    injectClickAnalytics: injectClickAnalytics
                });
            }
        default:
            return undefined;
    }
}
function $3a24b12925157d12$var$renderCrossAppItem({ responseItem: responseItem, context: context, product: product, subProduct: subProduct, injectClickAnalytics: injectClickAnalytics }) {
    switch(responseItem.type){
        case 'platform':
            return $3a24b12925157d12$var$renderPlatformCrossAppItem({
                responseItem: responseItem,
                context: context,
                product: product,
                subProduct: subProduct,
                injectClickAnalytics: injectClickAnalytics
            });
        case 'link':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $7dec05f53c1ad0f4$export$995913b4338229ea), {
                responseItem: responseItem,
                context: context,
                product: product,
                injectClickAnalytics: injectClickAnalytics
            });
        default:
            break;
    }
    return undefined;
}
function $3a24b12925157d12$var$CrossAppItemInner({ responseItem: responseItem, context: context, product: product, subProduct: subProduct, injectClickAnalytics: injectClickAnalytics }) {
    const renderedItem = $3a24b12925157d12$var$renderCrossAppItem({
        responseItem: responseItem,
        context: context,
        product: product,
        subProduct: subProduct,
        injectClickAnalytics: injectClickAnalytics
    });
    if (renderedItem !== undefined) return renderedItem;
    // Return general cross-app item with no customisedItemConfig
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4ef2ae8434994ccc$export$671e3c96b60c4286), {
        responseItem: responseItem,
        context: context,
        injectClickAnalytics: injectClickAnalytics
    });
}
function $3a24b12925157d12$export$93ca0712ad6ac26d(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($3a24b12925157d12$var$CrossAppItemInner, {
            ...props
        })
    });
}





const $5872fbca13241433$export$964d21685ad57bfa = (item)=>{
    return 'children' in item && !('type' in item);
};
function $5872fbca13241433$export$2e2bcd8739ae039({ item: item, itemIndex: itemIndex, totalMenuItemsCount: totalMenuItemsCount, sectionStartIndex: sectionStartIndex, sectionItemsCount: sectionItemsCount, isInMore: isInMore, sectionFoldableBehaviour: sectionFoldableBehaviour }) {
    const { crossAppCreationConfig: crossAppCreationConfig, product: product, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    const { fireNewMenuItemClicked: fireNewMenuItemClicked } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const fireAnalytics = (0, $42omo.useCallback)((props)=>{
        if ((0, $dh538.fg)('navx_uc_cross_app_creation_v2_enabled')) {
            const itemAti = $5872fbca13241433$export$964d21685ad57bfa(item) ? item.ati.toString() : item.ati || 'unknown';
            fireNewMenuItemClicked({
                ati: itemAti,
                itemType: props.itemType,
                sectionType: 'appDefinedSection',
                groupItemProduct: product,
                groupItemCount: sectionItemsCount,
                groupItemIndex: itemIndex,
                menuItemCount: totalMenuItemsCount,
                menuItemIndex: sectionStartIndex + itemIndex,
                isNativeItem: props.itemType === 'native',
                isRightClick: props.isRightClick,
                isInMore: isInMore,
                sectionFoldableBehaviour: sectionFoldableBehaviour
            });
        }
    }, [
        fireNewMenuItemClicked,
        item,
        itemIndex,
        totalMenuItemsCount,
        sectionStartIndex,
        sectionItemsCount,
        product,
        isInMore,
        sectionFoldableBehaviour
    ]);
    const menuItemWithAnalytics = (0, $42omo.useCallback)((item)=>{
        if ($5872fbca13241433$export$964d21685ad57bfa(item)) return {
            ...item,
            onClick: (event)=>{
                fireAnalytics({
                    isRightClick: false,
                    itemType: 'native'
                });
                item.onClick?.(event);
            },
            onContextMenu: (event)=>{
                fireAnalytics({
                    isRightClick: true,
                    itemType: 'native'
                });
                item.onContextMenu?.(event);
            }
        };
        return item;
    }, [
        fireAnalytics
    ]);
    const handleCrossAppItemClickAnalytics = (0, $42omo.useCallback)((isRightClick)=>{
        // Determine itemType dynamically based on whether item is native or cross-app
        const itemType = $5872fbca13241433$export$964d21685ad57bfa(item) ? 'native' : item.type;
        fireAnalytics({
            isRightClick: isRightClick,
            itemType: itemType
        });
    }, [
        fireAnalytics,
        item
    ]);
    const menuItem = menuItemWithAnalytics(item);
    // Check if this is a native menu item
    if ($5872fbca13241433$export$964d21685ad57bfa(menuItem)) // Render native menu item using existing MenuItem component
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e5Nax.default), {
        item: menuItem
    });
    // For cross-app items, check if context exists and is enabled
    if (!crossAppCreationConfig.enabled) return null;
    // Render cross-app item with injected analytics
    const injectClickAnalytics = {
        onClick: handleCrossAppItemClickAnalytics
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3a24b12925157d12$export$93ca0712ad6ac26d), {
        responseItem: menuItem,
        context: crossAppCreationConfig,
        product: product,
        subProduct: subProduct,
        injectClickAnalytics: injectClickAnalytics
    });
}



var $7K83z = parcelRequire("7K83z");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $bedQP = parcelRequire("bedQP");












var $2FkI9 = parcelRequire("2FkI9");




const $6530a2f588fdf043$var$LEGACY_MAX_ITEMS = 10;
const $6530a2f588fdf043$var$OVERFLOW_MAX_ITEMS = 50;
const $6530a2f588fdf043$var$RenderableMenuSectionInnerWithFG = (0, $bedQP.componentWithFG)('navx-2713-persist-more-state', $6530a2f588fdf043$var$RenderableMenuSectionInnerV2, $6530a2f588fdf043$var$RenderableMenuSectionInnerV1);
const $6530a2f588fdf043$export$47b6a3742898d49e = (0, $fNh3C.withIntlProvider)($6530a2f588fdf043$var$RenderableMenuSectionInnerWithFG);
function $6530a2f588fdf043$var$RenderableMenuSectionInnerV2({ section: section, sectionIndex: sectionIndex, sectionStartIndex: sectionStartIndex, totalMenuItemsCount: totalMenuItemsCount }) {
    const [localShowAll, setLocalShowAll] = (0, $42omo.useState)(false);
    const { fireShowMoreButtonClicked: fireShowMoreButtonClicked } = (0, $7K3dX.useUniversalCreateAnalytics)();
    // Use persistent state from context, fallback to local state for backwards compatibility
    const { sectionExpansionState: sectionExpansionState, setSectionExpansionState: setSectionExpansionState } = (0, $19BZl.useSectionExpansionContext)();
    const showAll = sectionExpansionState[sectionIndex] ?? localShowAll;
    const setShowAll = (0, $42omo.useCallback)((value)=>{
        const newValue = typeof value === 'function' ? value(showAll) : value;
        if ((0, $dh538.fg)('navx-2713-persist-more-state')) setSectionExpansionState(sectionIndex, newValue);
        else setLocalShowAll(newValue);
    }, [
        setSectionExpansionState,
        sectionIndex,
        showAll
    ]);
    const sectionItems = section.items;
    const sectionItemsCount = sectionItems.length;
    const foldableThreshold = (0, $7K83z.getFoldableThreshold)(section.foldable);
    const items = (0, $42omo.useMemo)(()=>{
        if (!sectionItemsCount) return [];
        if (!section.foldable || sectionItemsCount <= foldableThreshold) return sectionItems;
        const sectionItemsLimit = (0, $dh538.fg)('navx_universal_create_overflow_mode') ? $6530a2f588fdf043$var$OVERFLOW_MAX_ITEMS : $6530a2f588fdf043$var$LEGACY_MAX_ITEMS;
        return sectionItems.slice(0, showAll ? sectionItemsLimit : foldableThreshold);
    }, [
        section.foldable,
        sectionItems,
        showAll,
        sectionItemsCount,
        foldableThreshold
    ]);
    // Determine if an item is in the "show more" section
    const isItemInMore = (itemIndex)=>{
        if (!section.foldable || sectionItemsCount <= foldableThreshold) return false;
        return itemIndex >= foldableThreshold;
    };
    const toggleShowMore = (0, $42omo.useCallback)(()=>{
        if (typeof section.foldable === 'number' && (0, $dh538.fg)('navx-2610-uc-refactor-show-more')) {
            setShowAll(true); // removing show less functionality under this fg
            fireShowMoreButtonClicked({
                groupHeading: section.heading || 'unknown',
                groupIndex: sectionIndex,
                groupItemCount: sectionItemsCount,
                inMoreItemAtisList: sectionItems.slice(foldableThreshold).map((item)=>item.ati.toString()),
                inMoreItemCount: sectionItemsCount - foldableThreshold
            });
        } else setShowAll((prev)=>!prev);
    }, [
        setShowAll,
        section,
        sectionIndex,
        sectionItemsCount,
        fireShowMoreButtonClicked,
        foldableThreshold,
        sectionItems
    ]);
    if (!sectionItems?.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2FkI9.default), {
        sectionIndex: sectionIndex,
        itemLength: sectionItems.length,
        foldable: section.foldable,
        heading: section.heading,
        showAll: showAll,
        toggleShowMore: toggleShowMore,
        isNative: true,
        children: items.map((menuItem, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5872fbca13241433$export$2e2bcd8739ae039), {
                item: menuItem,
                itemIndex: index,
                sectionStartIndex: sectionStartIndex,
                sectionItemsCount: sectionItemsCount,
                totalMenuItemsCount: totalMenuItemsCount,
                isInMore: isItemInMore(index),
                sectionFoldableBehaviour: section.foldable
            }, `menu-section-${sectionIndex}-item-${index}`))
    });
}
function $6530a2f588fdf043$var$RenderableMenuSectionInnerV1({ section: section, sectionIndex: sectionIndex, sectionStartIndex: sectionStartIndex, totalMenuItemsCount: totalMenuItemsCount }) {
    const [showAll, setShowAll] = (0, $42omo.useState)(false);
    const { fireShowMoreButtonClicked: fireShowMoreButtonClicked } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const sectionItems = section.items;
    const sectionItemsCount = sectionItems.length;
    const foldableThreshold = (0, $7K83z.getFoldableThreshold)(section.foldable);
    const items = (0, $42omo.useMemo)(()=>{
        if (!sectionItemsCount) return [];
        if (!section.foldable || sectionItemsCount <= foldableThreshold) return sectionItems;
        const sectionItemsLimit = (0, $dh538.fg)('navx_universal_create_overflow_mode') ? $6530a2f588fdf043$var$OVERFLOW_MAX_ITEMS : $6530a2f588fdf043$var$LEGACY_MAX_ITEMS;
        return sectionItems.slice(0, showAll ? sectionItemsLimit : foldableThreshold);
    }, [
        section.foldable,
        sectionItems,
        showAll,
        sectionItemsCount,
        foldableThreshold
    ]);
    // Determine if an item is in the "show more" section
    const isItemInMore = (itemIndex)=>{
        if (!section.foldable || sectionItemsCount <= foldableThreshold) return false;
        return itemIndex >= foldableThreshold;
    };
    const toggleShowMore = (0, $42omo.useCallback)(()=>{
        if (typeof section.foldable === 'number' && (0, $dh538.fg)('navx-2610-uc-refactor-show-more')) {
            setShowAll(true); // removing show less functionality under this fg
            fireShowMoreButtonClicked({
                groupHeading: section.heading || 'unknown',
                groupIndex: sectionIndex,
                groupItemCount: sectionItemsCount,
                inMoreItemAtisList: sectionItems.slice(foldableThreshold).map((item)=>item.ati.toString()),
                inMoreItemCount: sectionItemsCount - foldableThreshold
            });
        } else setShowAll((prev)=>!prev);
    }, [
        setShowAll,
        section,
        sectionIndex,
        sectionItemsCount,
        fireShowMoreButtonClicked,
        foldableThreshold,
        sectionItems
    ]);
    if (!sectionItems?.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2FkI9.default), {
        sectionIndex: sectionIndex,
        itemLength: sectionItems.length,
        foldable: section.foldable,
        heading: section.heading,
        showAll: showAll,
        toggleShowMore: toggleShowMore,
        isNative: true,
        children: items.map((menuItem, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5872fbca13241433$export$2e2bcd8739ae039), {
                item: menuItem,
                itemIndex: index,
                sectionStartIndex: sectionStartIndex,
                sectionItemsCount: sectionItemsCount,
                totalMenuItemsCount: totalMenuItemsCount,
                isInMore: isItemInMore(index),
                sectionFoldableBehaviour: section.foldable
            }, `menu-section-${sectionIndex}-item-${index}`))
    });
}



var $a5rWO = parcelRequire("a5rWO");


var $6oodB = parcelRequire("6oodB");

const $cfff25737a37447f$var$filterNativeItems = (items)=>items.filter((0, $6oodB.isNativeMenuItem));
/**
 * Sorts items to place promoted items at the top while preserving relative order.
 * Uses stable sort to maintain original order within promoted and non-promoted groups.
 *
 * @param items - Array of items with optional promoted flag
 * @returns New array with promoted items first, maintaining relative order
 *
 * @example
 * Input:  [A, B(promoted), C, D(promoted)]
 * Output: [B(promoted), D(promoted), A, C]
 */ const $cfff25737a37447f$var$sortByPromoted = (items)=>{
    const promotedItems = [];
    const regularItems = [];
    items.forEach((item)=>{
        if (item.promoted === true) promotedItems.push(item);
        else regularItems.push(item);
    });
    return [
        ...promotedItems,
        ...regularItems
    ];
};
const $cfff25737a37447f$var$createSection = (configSection, items, personalized)=>({
        type: 'appDefinedSection',
        heading: configSection.heading,
        foldable: configSection.foldable,
        items: items,
        personalized: personalized
    });
const $cfff25737a37447f$var$createConfigItemsMap = (items)=>new Map(items.filter((0, $6oodB.isNativeMenuItem)).map((item)=>[
            item.ati.toString(),
            item
        ]));
const $cfff25737a37447f$var$hydrateResponseItem = (responseItem, configItemsByAti)=>{
    // Cross-app item: use as-is from response
    if (responseItem.type !== 'native') return responseItem;
    // Native item: find corresponding config item with full data
    const configItem = configItemsByAti.get(responseItem.ati);
    return configItem ?? null;
};
const $cfff25737a37447f$var$hydrateSection = (configSection, responseSection)=>{
    // No response section: return native items only with promoted items at the top
    if (!responseSection) {
        const nativeItems = $cfff25737a37447f$var$filterNativeItems(configSection.items);
        const sortedItems = $cfff25737a37447f$var$sortByPromoted(nativeItems);
        return sortedItems.length > 0 ? $cfff25737a37447f$var$createSection(configSection, sortedItems) : null;
    }
    // Use response order: map each response item to its hydrated version
    const configItemsByAti = $cfff25737a37447f$var$createConfigItemsMap(configSection.items);
    const hydratedItems = responseSection.items.map((responseItem)=>$cfff25737a37447f$var$hydrateResponseItem(responseItem, configItemsByAti)).filter((item)=>item !== null);
    return hydratedItems.length > 0 ? $cfff25737a37447f$var$createSection(configSection, hydratedItems, responseSection.personalized) : null;
};
const $cfff25737a37447f$export$f60e04956fac8ba8 = (data, sections)=>{
    const appDefinedSectionsFromResponse = data.sections.filter((section)=>section.type === 'appDefinedSection');
    // Map each config section to its hydrated version
    // Keep null entries to maintain index alignment with config sections
    return sections.map((configSection, index)=>$cfff25737a37447f$var$hydrateSection(configSection, appDefinedSectionsFromResponse[index]));
};
const $cfff25737a37447f$export$fd0ba75bb069af58 = (sections)=>sections.map((section)=>{
        const nativeItems = $cfff25737a37447f$var$filterNativeItems(section.items);
        const sortedItems = $cfff25737a37447f$var$sortByPromoted(nativeItems);
        return sortedItems.length > 0 ? $cfff25737a37447f$var$createSection(section, sortedItems) : null;
    }).filter((section)=>section !== null);


const $7aed742ac61dd32a$export$f6dc3460757f5999 = (section)=>section.type === 'appDefinedSection';
const $7aed742ac61dd32a$export$9ba1633297a665ab = (section)=>section.type === 'suggestionSection';
const $7aed742ac61dd32a$export$f3cccc0ced3c2bed = (sections)=>sections.filter($7aed742ac61dd32a$export$f6dc3460757f5999);
/**
 * Processes a single suggestion section by matching it with a response section.
 * Suggestion sections contain directly renderable items from the backend.
 * Only cross-app items are included (native item references are filtered out).
 */ const $7aed742ac61dd32a$var$processSuggestionSection = (configSection, responseSection)=>{
    if (!responseSection || responseSection.items.length === 0) return null;
    return {
        type: 'suggestionSection',
        heading: configSection.heading,
        foldable: configSection.foldable,
        items: responseSection.items
    };
};
/**
 * Hydrates app-defined sections by matching native items from the API response with configured sections.
 *
 * This function:
 * 1. Takes the API response data and the original sections configuration
 * 2. For each app-defined section in the configuration:
 *    - Uses section metadata (heading, foldable, etc.) from config
 *    - Uses item ordering from the response
 *    - For native items: finds matching config item by ATI to preserve properties (onClick, children, etc.)
 *    - For cross-app items: uses data directly from response
 * 3. Returns hydrated sections ready for rendering
 *
 * Note: Sections with no items after hydration are filtered out (returns null in array).
 */ const $7aed742ac61dd32a$var$hydrateAppDefinedSections = (configSections, data)=>{
    return (0, $cfff25737a37447f$export$f60e04956fac8ba8)(data, configSections);
};
const $7aed742ac61dd32a$export$d02f102e1bd204d6 = ({ sections: sections, data: data, hasError: hasError, isNativeOnly: isNativeOnly })=>{
    // Error/no data/native-only case: return only native items from app-defined sections
    if (hasError || !data || isNativeOnly) {
        const appDefinedSections = $7aed742ac61dd32a$export$f3cccc0ced3c2bed(sections);
        return (0, $cfff25737a37447f$export$fd0ba75bb069af58)(appDefinedSections);
    }
    // Separate sections by type for processing
    const suggestionResponseSections = data.sections.filter((section)=>section.type === 'suggestionSection');
    const appDefinedConfigSections = $7aed742ac61dd32a$export$f3cccc0ced3c2bed(sections);
    // Hydrate app-defined sections with response data
    // This returns an array that may contain null entries for sections that couldn't be hydrated
    const hydratedAppSections = $7aed742ac61dd32a$var$hydrateAppDefinedSections(appDefinedConfigSections, data);
    // Process sections in original order, matching with response data
    // Use separate indices to track position in filtered arrays
    let suggestionIndex = 0;
    let appSectionIndex = 0;
    return sections.map((configSection)=>{
        if ($7aed742ac61dd32a$export$9ba1633297a665ab(configSection)) {
            const responseSection = suggestionResponseSections[suggestionIndex++];
            return $7aed742ac61dd32a$var$processSuggestionSection(configSection, responseSection);
        }
        if ($7aed742ac61dd32a$export$f6dc3460757f5999(configSection)) {
            // Get the hydrated section (may be null if hydration failed)
            const hydratedSection = hydratedAppSections[appSectionIndex++];
            return hydratedSection;
        }
        return null;
    }).filter((section)=>section !== null);
};
const $7aed742ac61dd32a$export$a628dce1485ab731 = (sections)=>sections.reduce((total, section)=>total + section.items.length, 0);
const $7aed742ac61dd32a$export$15c1c48db7fb6757 = (sections)=>{
    let totalCount = 0;
    const startIndices = [];
    sections.forEach((section)=>{
        startIndices.push(totalCount);
        totalCount += section.items.length;
    });
    return {
        totalCount: totalCount,
        startIndices: startIndices
    };
};


const $9aa5319017567367$var$styles = {
    menuWrap: "_ca0qu2gc _n3tdu2gc"
};
function $9aa5319017567367$var$MenuContentV2Inner() {
    const { locale: locale } = (0, $8C5kA.default)();
    const { sections: sections, crossAppCreationConfig: crossAppCreationConfig, product: product, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    const { cloudId: cloudId = '', orgId: orgId = '', accountId: accountId = '' } = crossAppCreationConfig?.enabled ? crossAppCreationConfig : {};
    // Determine if we're in native-only mode (no cross-app creation)
    const isNativeOnly = !crossAppCreationConfig?.enabled; // Skip appMenuConfig generation when in native-only mode
    const appMenuConfig = (0, $42omo.useMemo)(()=>(0, $a5rWO.sectionsToAppMenuConfig)(isNativeOnly ? [] : sections), [
        isNativeOnly,
        sections
    ]);
    const { data: data, isLoading: isLoading, hasError: hasError, fetchUCMenuItems: fetchUCMenuItems } = (0, $a1Oiu.useUCMenuItems)({
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        subProduct: subProduct,
        userId: accountId,
        locale: locale,
        appMenuConfig: appMenuConfig,
        skipInitialization: isNativeOnly
    });
    // Fetch menu items when cross-app creation is enabled
    (0, $42omo.useEffect)(()=>{
        if (crossAppCreationConfig?.enabled) fetchUCMenuItems();
    }, [
        crossAppCreationConfig?.enabled,
        fetchUCMenuItems
    ]);
    const renderableSections = (0, $42omo.useMemo)(()=>(0, $7aed742ac61dd32a$export$d02f102e1bd204d6)({
            sections: sections,
            data: data,
            hasError: hasError,
            isNativeOnly: isNativeOnly
        }), [
        sections,
        data,
        hasError,
        isNativeOnly
    ]);
    const sectionsToAnalyze = (0, $42omo.useMemo)(()=>renderableSections.slice(0, (0, $jjCkw.MAX_ALLOWED_SECTIONS)), [
        renderableSections
    ]); // Pre-compute section metadata (start indices and total count) to avoid O(n²) complexity
    const sectionMetadata = (0, $42omo.useMemo)(()=>(0, $7aed742ac61dd32a$export$15c1c48db7fb6757)(sectionsToAnalyze), [
        sectionsToAnalyze
    ]); // Only show loading state when cross-app creation is enabled
    // This ensures native-only items render immediately when cross-app is disabled
    if (isLoading && crossAppCreationConfig?.enabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $amdkE.LoadingMenu), {
        padded: true
    });
    if (sectionsToAnalyze.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        spacing: "compact",
        testId: "global-create-content-popover-menu-v2",
        ...sectionsToAnalyze.some((section)=>typeof section.foldable === 'number') && (0, $dh538.fg)('navx_universal_create_overflow_mode') ? {
            maxHeight: (0, $jjCkw.MAX_MENU_HEIGHT)
        } : undefined,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($9aa5319017567367$var$styles.menuWrap),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)($9aa5319017567367$export$db78b92a799823ab, {
                    sections: sectionsToAnalyze
                }),
                sectionsToAnalyze.map((section, sectionIndex)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6530a2f588fdf043$export$47b6a3742898d49e), {
                        section: section,
                        sectionIndex: sectionIndex,
                        totalMenuItemsCount: sectionMetadata.totalCount,
                        sectionStartIndex: sectionMetadata.startIndices[sectionIndex]
                    }, `menu-section-${section.type}-${sectionIndex}`))
            ]
        })
    });
}
function $9aa5319017567367$export$db78b92a799823ab({ sections: sections }) {
    const { fireNewMenuItemsViewed: fireNewMenuItemsViewed } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const analyticsFired = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (sections.length === 0 || analyticsFired.current) return;
        if ((0, $dh538.fg)('navx_uc_cross_app_creation_v2_enabled')) {
            analyticsFired.current = true;
            const crossAppCreationEnabled = (0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled'); // Flatten all items from all sections
            const allItems = sections.flatMap((section)=>section.items); // Build metadata for each section
            const sectionMetadata = sections.map((section, sectionIndex)=>{
                const sectionItems = section.items; // Extract all ATIs and types from items in this section
                const sectionItemAtis = sectionItems.map((item)=>(0, $5872fbca13241433$export$964d21685ad57bfa)(item) ? item.ati.toString() : item.ati || 'unknown');
                const sectionItemTypes = sectionItems.map((item)=>(0, $5872fbca13241433$export$964d21685ad57bfa)(item) ? 'native' : item.type);
                const moreButtonEnabled = (0, $7K83z.hasMoreButton)(section.foldable, sectionItems.length);
                const inMoreItemAtisList = moreButtonEnabled ? sectionItems.slice((0, $7K83z.getFoldableThreshold)(section.foldable)).map((item)=>item.ati.toString()) : undefined;
                const inMoreItemCount = moreButtonEnabled ? sectionItems.length - (0, $7K83z.getFoldableThreshold)(section.foldable) : undefined; // Create metadata object for this section
                const baseMetadata = {
                    groupHeading: section.heading,
                    groupIndex: sectionIndex,
                    groupItemCount: sectionItems.length,
                    groupItemAtisList: sectionItemAtis,
                    itemTypes: sectionItemTypes,
                    showMoreButton: moreButtonEnabled,
                    inMoreItemAtisList: inMoreItemAtisList,
                    inMoreItemCount: inMoreItemCount
                }; // Add type-specific properties
                if (section.type === 'appDefinedSection') return {
                    ...baseMetadata,
                    type: 'appDefinedSection',
                    personalize: section.personalized ?? 'off'
                };
                else return {
                    ...baseMetadata,
                    type: 'suggestionSection'
                };
            });
            // Fire analytics event with aggregated data
            fireNewMenuItemsViewed({
                crossAppCreationEnabled: crossAppCreationEnabled,
                groupCount: sections.length,
                groupList: sectionMetadata,
                totalCrossAppItemCount: allItems.filter((item)=>!(0, $5872fbca13241433$export$964d21685ad57bfa)(item)).length,
                totalNativeItemCount: allItems.filter((0, $5872fbca13241433$export$964d21685ad57bfa)).length
            });
        }
    }, [
        sections,
        fireNewMenuItemsViewed
    ]);
    return null;
}
const $9aa5319017567367$var$MenuContentV2WithIntl = (0, $fNh3C.withIntlProvider)($9aa5319017567367$var$MenuContentV2Inner);
const $9aa5319017567367$export$d54d952454c9bc12 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($9aa5319017567367$var$MenuContentV2WithIntl, {})
    });
module.exports["MenuContentV2"] = $9aa5319017567367$export$d54d952454c9bc12;

});

parcelRegister("kbvzd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $dh538 = parcelRequire("dh538");


var $fP8Uu = parcelRequire("fP8Uu");


var $gWF6I = parcelRequire("gWF6I");


var $19BZl = parcelRequire("19BZl");


var $fMjA6 = parcelRequire("fMjA6");

var $6OnN8 = parcelRequire("6OnN8");

function $6477ac45fd3dd7b4$export$98eff9c5659394e3({ children: children }) {
    const crossAppCreationEnabled = (0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled');
    const { product: product, suggestionConfig: suggestionConfig, subProduct: subProduct } = (0, $19BZl.useMenuControl)();
    const { locale: locale } = (0, $8C5kA.default)();
    // Use the shared hooks for ATIs logic
    const nativeAtis = (0, $6OnN8.useSuggestionNativeAtis)();
    const preferredAtis = (0, $fMjA6.useSuggestionPreferredAtis)();
    const excludeAtis = (0, $fMjA6.useSuggestionExcludeAtis)();
    const { data: data, fetchUCSuggestions: fetchUCSuggestions } = (0, $fP8Uu.useUCSuggestions)({
        cloudId: suggestionConfig.enabled ? suggestionConfig.cloudId : '',
        orgId: suggestionConfig.enabled ? suggestionConfig.orgId : '',
        userId: suggestionConfig.enabled ? suggestionConfig.accountId : '',
        product: product,
        locale: locale,
        subProduct: suggestionConfig.enabled ? subProduct : undefined,
        nativeAtis: nativeAtis,
        preferredAtis: preferredAtis,
        excludeAtis: excludeAtis
    });
    const noDataInStore = (0, $42omo.useMemo)(()=>!data, [
        data
    ]);
    /**
   * This is the last fallback call when menu is opened by no data is in store
   */ (0, $42omo.useEffect)(function onMenuOpenFetch() {
        // TODO: add v2 fetch here
        if (noDataInStore && crossAppCreationEnabled && suggestionConfig.enabled) fetchUCSuggestions();
    }, [
        crossAppCreationEnabled,
        suggestionConfig.enabled,
        locale,
        noDataInStore,
        fetchUCSuggestions
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.ConditionalRelayEnvironmentProvider), {
        children: children
    });
}
module.exports["MenuWrapper"] = $6477ac45fd3dd7b4$export$98eff9c5659394e3;

});

parcelRegister("csJ3R", function(module, exports) {
/* formLoader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $9DI9J = parcelRequire("9DI9J");


var $b2OKi = parcelRequire("b2OKi");


const $b19599a70b1ea9c9$var$GoalCreateWrapperAsync = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3IXul")).then((module)=>({
            default: module.GoalCreateWrapper
        })));

const $b19599a70b1ea9c9$var$TeamCreateWrapperAsync = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kkzdO")).then((module)=>({
            default: module.TeamCreateWrapper
        })));

const $b19599a70b1ea9c9$var$ProjectCreateWrapperAsync = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("53RUv")).then((module)=>({
            default: module.ProjectCreateWrapper
        })));
function $b19599a70b1ea9c9$var$LazyLoadCreateContent({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $b2OKi.FormLoading), {}),
            children: children
        })
    });
}
const $b19599a70b1ea9c9$var$CREATE_CONTENT_PRESETS = {
    [(0, $9DI9J.ATI_PRESETS).GOAL]: (props)=>/*#__PURE__*/ (0, $l998X.jsx)($b19599a70b1ea9c9$var$LazyLoadCreateContent, {
            children: /*#__PURE__*/ (0, $l998X.jsx)($b19599a70b1ea9c9$var$GoalCreateWrapperAsync, {
                ...props
            })
        }),
    [(0, $9DI9J.ATI_PRESETS).TEAM]: (props)=>/*#__PURE__*/ (0, $l998X.jsx)($b19599a70b1ea9c9$var$LazyLoadCreateContent, {
            children: /*#__PURE__*/ (0, $l998X.jsx)($b19599a70b1ea9c9$var$TeamCreateWrapperAsync, {
                ...props
            })
        }),
    [(0, $9DI9J.ATI_PRESETS).PROJECT]: (props)=>/*#__PURE__*/ (0, $l998X.jsx)($b19599a70b1ea9c9$var$LazyLoadCreateContent, {
            children: /*#__PURE__*/ (0, $l998X.jsx)($b19599a70b1ea9c9$var$ProjectCreateWrapperAsync, {
                ...props
            })
        })
};
function $b19599a70b1ea9c9$export$38e36ff3c4cb0c61(ati) {
    return $b19599a70b1ea9c9$var$CREATE_CONTENT_PRESETS[ati];
}
module.exports["getCreateContentLoader"] = $b19599a70b1ea9c9$export$38e36ff3c4cb0c61;

});

parcelRegister("33MPL", function(module, exports) {





















function $807ba750c6a5720b$var$importIcon(name) {
    switch(name){
        // lab-icons start
        case 'page-live-doc':
            return Promise.resolve((parcelRequire("e0ycV")));
        case 'suggested-edit':
            return (parcelRequire("53z01"));
        // lab-icons end
        case 'board':
            return Promise.resolve((parcelRequire("5aaqS")));
        case 'page':
            return Promise.resolve((parcelRequire("8jHAi")));
        case 'video':
            return Promise.resolve((parcelRequire("2Yaht")));
        case 'database':
            return Promise.resolve((parcelRequire("6B0jU")));
        case 'whiteboard':
            return Promise.resolve((parcelRequire("ZDq1z")));
        case 'quotation-mark':
            return Promise.resolve((parcelRequire("9RVmI")));
        case 'smart-link':
            return Promise.resolve((parcelRequire("duwSm")));
        case 'globe':
            return Promise.resolve((parcelRequire("buthI")));
        case 'teams':
            return Promise.resolve((parcelRequire("1dKyn")));
        case 'goal':
            return Promise.resolve((parcelRequire("gJsgh")));
        case 'project':
            return Promise.resolve((parcelRequire("bVHZY")));
        case 'heart':
            return Promise.resolve((parcelRequire("j8LwF")));
        case 'dashboard':
            return (parcelRequire("036Ie"));
        case 'work-item':
            return Promise.resolve((parcelRequire("2qVkt")));
        case 'work-items':
            return Promise.resolve((parcelRequire("7ZcJJ")));
        case 'roadmap':
            return (parcelRequire("k8V49"));
        case 'sprint':
            return (parcelRequire("fq08g"));
        case 'focus-area':
            return (parcelRequire("eNNHQ"));
        case 'calendar-plus':
            return (parcelRequire("ji6i4"));
        default:
            throw new Error(`Icon ${name} not found`);
    }
}
async function $807ba750c6a5720b$export$832efc97cccfe549(icon) {
    try {
        if (!icon) return undefined;
        const iconModule = await $807ba750c6a5720b$var$importIcon(icon);
        return iconModule ? iconModule.default : undefined;
    } catch  {
        return undefined;
    }
}
module.exports["iconLoader"] = $807ba750c6a5720b$export$832efc97cccfe549;

});

parcelRegister("e5Nax", function(module, exports) {
$parcel$export(module.exports, "default", () => $036eedccb5a0b632$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $lAJUP = parcelRequire("lAJUP");


var $4rwCt = parcelRequire("4rwCt");


var $56M4r = parcelRequire("56M4r");

var $cGtPE = parcelRequire("cGtPE");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");


var $3gadb = parcelRequire("3gadb");


var $19BZl = parcelRequire("19BZl");


var $lz3e7 = parcelRequire("lz3e7");


var $7WMLZ = parcelRequire("7WMLZ");


var $iXlHQ = parcelRequire("iXlHQ");

const $036eedccb5a0b632$var$textStyle = null; // Function to check if the element's text is truncated
function $036eedccb5a0b632$var$isTextClamped(labelElement, boxElement) {
    return labelElement.scrollWidth > boxElement.scrollWidth;
}
const $036eedccb5a0b632$var$Item = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onClick: onClick, onContextMenu: onContextMenu, isLoading: isLoading, loadCreateContent: createContent, onClickCloseMenu: onClickCloseMenu = true, children: children, testId: testId, isDisabled: isDisabled, href: href, rel: rel, target: target, elemBefore: elemBefore, Wrapper: Wrapper }, forwardRef)=>{
    const { product: product, ...menuControl } = (0, $19BZl.useMenuControl)();
    const labelRef = (0, $42omo.useRef)(null);
    const buttonClick = (0, $42omo.useCallback)((event)=>{
        if (createContent) menuControl.load(createContent);
        else if (onClickCloseMenu) menuControl.close();
        onClick?.(event);
    }, [
        menuControl,
        onClick,
        onClickCloseMenu,
        createContent
    ]);
    const renderButton = (0, $42omo.useCallback)((props)=>{
        const { triggerProps: triggerProps } = props || {};
        const { ref: triggerRef, ...restTriggerProps } = triggerProps || {};
        const mergedRef = (0, $4rwCt.mergeRefs)([
            ...forwardRef ? [
                forwardRef
            ] : [],
            ...triggerRef ? [
                triggerRef
            ] : []
        ]);
        const Icon = elemBefore;
        const baseProps = {
            testId: testId,
            iconBefore: Icon ? /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                label: "",
                color: "var(--ds-text-subtle, #505258)"
            }) : undefined,
            onClick: buttonClick,
            onContextMenu: onContextMenu,
            className: 'custom-item-style',
            children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_1t5c13mh _1t211l2s _1xdi1ule"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    ref: labelRef,
                    maxLines: 1,
                    color: "color.text.subtle",
                    weight: "medium",
                    children: children
                })
            })
        };
        const canTooltipAppear = ()=>{
            return labelRef.current && mergedRef.current ? $036eedccb5a0b632$var$isTextClamped(labelRef.current, mergedRef.current) : false;
        };
        const itemProps = {
            ...baseProps,
            ...restTriggerProps,
            ...mergedRef && {
                ref: mergedRef
            },
            href: href,
            rel: rel,
            target: target,
            isDisabled: isDisabled
        };
        const buttonItemProps = (0, $lz3e7.omitSafely)(itemProps, 'href', 'rel', 'target', 'role', 'UNSAFE_shouldDisableRouterLink', 'UNSAFE_isDraggable');
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: children,
            canAppear: canTooltipAppear,
            children: href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
                ...itemProps
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                ...buttonItemProps
            })
        });
    }, [
        testId,
        elemBefore,
        buttonClick,
        children,
        forwardRef,
        href,
        rel,
        isDisabled,
        target,
        onContextMenu
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $7WMLZ.SkeletonItem), {
        testId: `loading-${testId}`
    });
    if ((0, $dh538.fg)('navx_uc_wrapper_prop_re_enabled')) {
        if (Wrapper) return /*#__PURE__*/ (0, $l998X.jsx)(Wrapper, {
            children: (props)=>renderButton(props)
        });
    } else {
        if ([
            'confluence',
            'jira'
        ].includes(product) && Wrapper) return /*#__PURE__*/ (0, $l998X.jsx)(Wrapper, {
            children: (props)=>renderButton(props)
        });
    }
    return renderButton();
});
function $036eedccb5a0b632$export$2e2bcd8739ae039({ item: item }) {
    const { ref: ref, ...props } = item;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXlHQ.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)($036eedccb5a0b632$var$Item, {
                ...props,
                ref: ref
            })
        })
    });
}

});

parcelRegister("7K83z", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $c7ff952e8f6fa36a$export$398dd7520d5d04c0 = 4;
function $c7ff952e8f6fa36a$export$e69afd517cd76d77(foldable) {
    return typeof foldable === 'number' ? foldable : $c7ff952e8f6fa36a$export$398dd7520d5d04c0;
}
function $c7ff952e8f6fa36a$export$1093f66bab07389e(foldable, itemLength) {
    return typeof foldable === 'number' && itemLength > $c7ff952e8f6fa36a$export$e69afd517cd76d77(foldable) && (0, $dh538.fg)('navx-2610-uc-refactor-show-more');
}
function $c7ff952e8f6fa36a$export$9b76114550cc401f(foldable, itemLength) {
    return foldable === true && itemLength > $c7ff952e8f6fa36a$export$e69afd517cd76d77(foldable);
}
function $c7ff952e8f6fa36a$export$c8ef8ec3af207203(foldable, itemLength) {
    return $c7ff952e8f6fa36a$export$1093f66bab07389e(foldable, itemLength) || $c7ff952e8f6fa36a$export$9b76114550cc401f(foldable, itemLength);
}
module.exports["getFoldableThreshold"] = $c7ff952e8f6fa36a$export$e69afd517cd76d77;
module.exports["hasEnhancedMoreButton"] = $c7ff952e8f6fa36a$export$1093f66bab07389e;
module.exports["hasMoreButton"] = $c7ff952e8f6fa36a$export$c8ef8ec3af207203;

});

parcelRegister("2FkI9", function(module, exports) {
$parcel$export(module.exports, "default", () => $d690491b6d31182a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $56M4r = parcelRequire("56M4r");


var $iZRoG = parcelRequire("iZRoG");

var $9kbAI = parcelRequire("9kbAI");

var $2KDGn = parcelRequire("2KDGn");

var $2bhek = parcelRequire("2bhek");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $iXlHQ = parcelRequire("iXlHQ");


var $hDaa1 = parcelRequire("hDaa1");


var $7K83z = parcelRequire("7K83z");

const $d690491b6d31182a$var$styles = {
    menuWrap: "_ca0qu2gc _n3tdu2gc",
    textStyle: "_k48p1wq8 _ect41gqc _syazazsu"
};
const $d690491b6d31182a$var$restProps = {
    className: 'custom-item-style'
};
function $d690491b6d31182a$export$2e2bcd8739ae039({ heading: heading, sectionIndex: sectionIndex, itemLength: itemLength, foldable: foldable, compact: compact = false, isNative: isNative = true, toggleShowMore: toggleShowMore, children: children, showAll: showAll }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const text = showAll ? formatMessage((0, $hDaa1.showMoreMessages).showLess) : formatMessage((0, $hDaa1.showMoreMessages).showMore);
    if (!itemLength) return null;
     // when compact is true, it should hide both heading and divider
    // when compact is false or the section is native, it should only show the divider if it is not the first section
    const shouldShowDivider = (isNative || !compact) && sectionIndex !== 0;
    const shouldShowHeading = !!(heading && (isNative || !compact));
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2KDGn.MenuSection), {
        children: [
            shouldShowDivider && /*#__PURE__*/ (0, $l998X.jsx)((0, $iZRoG.Divider), {}),
            shouldShowHeading && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXlHQ.default), {
                isMenuItem: false,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2bhek.MenuSectionHeading), {
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9kbAI.MenuList), {
                children: children
            }),
            (0, $7K83z.hasMoreButton)(foldable, itemLength) && toggleShowMore && ((0, $7K83z.hasEnhancedMoreButton)(foldable, itemLength) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hDaa1.default), {
                onClick: toggleShowMore,
                heading: heading,
                showAll: showAll,
                foldable: foldable
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXlHQ.default), {
                isMenuItem: false,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                    ...$d690491b6d31182a$var$restProps,
                    iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                        label: "",
                        color: "var(--ds-text-subtle)"
                    }),
                    onClick: toggleShowMore,
                    testId: "toggle-more-less-button",
                    "aria-label": (0, $dh538.fg)('navx-2826-eslint-translation-fix-uc') ? formatMessage((0, $hDaa1.showMoreMessages).toggleAriaLabel, {
                        text: text,
                        heading: heading ? ` ${heading}` : ''
                    }) : `Toggle for ${text}${heading ? ` ${heading}` : ''} options`,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        xcss: $d690491b6d31182a$var$styles.textStyle,
                        children: text
                    })
                })
            }))
        ]
    }, `menu-section-${sectionIndex}`);
}

});

parcelRegister("b2OKi", function(module, exports) {
/* Loading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $6F6hl = parcelRequire("6F6hl");


var $amdkE = parcelRequire("amdkE");

const $8890500e2831b54e$var$styles = {
    wrapper: "_ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi _1bsb1gwv"
};
const $8890500e2831b54e$var$messages = (0, $cgtv4.defineMessages)({
    loading: {
        id: "platform.navigation-experiences.universal-create.integrations.form-loading",
        defaultMessage: "Loading"
    }
});
function $8890500e2831b54e$export$2f1709634d27333b() {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($8890500e2831b54e$var$styles.wrapper),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $amdkE.LoadingMenu), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                id: $8890500e2831b54e$var$messages.loading.id,
                children: formatMessage($8890500e2831b54e$var$messages.loading)
            })
        ]
    });
}
module.exports["FormLoading"] = $8890500e2831b54e$export$2f1709634d27333b;

});

parcelRegister("iXlHQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1f757cfbbc3d137$export$2e2bcd8739ae039);
/* item-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $d1f757cfbbc3d137$var$styles = null;
function $d1f757cfbbc3d137$export$2e2bcd8739ae039({ children: children, isMenuItem: isMenuItem = true }) {
    const wrappedItemRole = isMenuItem ? 'listitem' : undefined;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: wrappedItemRole,
        className: (0, $gMc0m.default)([
            "_19bvu2gc _u5f3u2gc _1bsb163w _1gxw12b0 _18tmu2gc _uckdu2gc _14ujn7od _1e3fazsu"
        ]),
        children: children
    });
}

});

parcelRegister("hDaa1", function(module, exports) {
$parcel$export(module.exports, "default", () => $867372c5edffcbdf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $iI2ST = parcelRequire("iI2ST");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $iXlHQ = parcelRequire("iXlHQ");

const $867372c5edffcbdf$var$styles = {
    textStyle: "_k48p1wq8 _ect41gqc _syazazsu"
};
const $867372c5edffcbdf$export$e32d6f5365665749 = (0, $cgtv4.defineMessages)({
    showMore: {
        id: "platform.navigation-experiences.universal-create.show-more",
        defaultMessage: "More"
    },
    showLess: {
        id: "platform.navigation-experiences.universal-create.show-less",
        defaultMessage: "Less"
    },
    showMoreAriaLabel: {
        id: "platform.navigation-experiences.universal-create.show-more.area-label",
        defaultMessage: "Show {text} {heading} options"
    },
    toggleAriaLabel: {
        id: "platform.navigation-experiences.universal-create.area-label",
        defaultMessage: "Toggle for {text}{heading} options"
    }
});
function $867372c5edffcbdf$export$2e2bcd8739ae039({ onClick: onClick, heading: heading, showAll: showAll, foldable: foldable }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const listItemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        // We render this button in a group, not a list, so we need to override the underlying component's semantics
        // because it wraps the button in a list item by default
        if (listItemRef.current) listItemRef.current.removeAttribute('role');
    }, []);
    const text = showAll ? formatMessage($867372c5edffcbdf$export$e32d6f5365665749.showLess) : formatMessage($867372c5edffcbdf$export$e32d6f5365665749.showMore);
    const handleClick = (0, $42omo.useCallback)(()=>{
        setExpanded(true);
        onClick();
    }, [
        onClick
    ]); // Hide the button if showAll is true or if it has been clicked (expanded)
    if (typeof foldable === 'number' && (showAll || expanded)) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iXlHQ.default), {
        isMenuItem: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iI2ST.ButtonMenuItem), {
            elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                label: "",
                color: "var(--ds-text-subtle, #505258)"
            }),
            onClick: handleClick,
            testId: "show-more-button",
            "aria-label": (0, $dh538.fg)('navx-2826-eslint-translation-fix-uc') ? formatMessage($867372c5edffcbdf$export$e32d6f5365665749.showMoreAriaLabel, {
                text: text,
                heading: heading ? ` ${heading}` : ''
            }) : `Show ${text} ${heading ? ` ${heading}` : ''} options`,
            listItemRef: listItemRef,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "span",
                xcss: $867372c5edffcbdf$var$styles.textStyle,
                children: text
            })
        })
    });
}
module.exports["showMoreMessages"] = $867372c5edffcbdf$export$e32d6f5365665749;

});


//# sourceMappingURL=AsyncPopupContent.be4cbfc8.js.map
